import { ChangeDetectorRef, Component, OnInit, ViewContainerRef } from '@angular/core';
import { Subscription } from 'rxjs';
import * as _ from 'lodash';
import { IFilter } from '../../../shared/interfaces/filter.interface';
import { Broadcaster } from '../../../shared/components/broadcaster.component';
import { AuthService } from '../../../shared/services/auth.service';
import { ExpensesReportService } from './expenses-report.service';


let self: any;

@Component({
  selector: 'app-expenses-report',
  templateUrl: './expenses-report.component.html',
  styleUrls: ['./expenses-report.component.css']
})
export class ExpensesreportComponent implements OnInit {
  expenses: any[] = [];
  loading: boolean = false;
  thereAreMore: boolean = false;
  filter: IFilter = {
    filters: {
      expensesDateStart: '2024-11-18',
      expensesDateEnd: '2024-11-19',
      isDeleted: false
    },
    sort: '',
    skip: 0,
    limit: 20
  };
  filtered = false;
  scrollSubscription!: Subscription;
  sortOptions: any = {
    "name": 'Nombre asc',
    "-name": 'Nombre desc',
  };
  sortOptionsKeys = Object.keys(this.sortOptions);
  selection: any = { all: false };
  isDev!: boolean;
  curr!: string;

  constructor(
    public _ExpensesReportService: ExpensesReportService,
    private _broadcaster: Broadcaster,
    private _AuthService: AuthService,
    private ref: ChangeDetectorRef
  ) {
    self = this;
    this.registerStringBroadcast();
  }

  ngOnInit() {
    this.isDev = this._AuthService.isRole('dev');
    this.filter.company = this._AuthService.companyId();
    this.curr = this._AuthService.currency();
    this.getExpensesReport(true);
  }

  lazySearchTmp: number = 0;
  lazySearch() {
    let tmp = new Date().getTime();
    this.lazySearchTmp = tmp;
    setTimeout(() => {
      if (tmp == this.lazySearchTmp) {
        this.getExpensesReport(true);
      }
    }, 1000);
  }

  getExpensesReport(reset?: boolean) {
    this.loading = true;
    this.thereAreMore = false;
    if (reset) {
      window.scroll(0, 0);
      this.filter.skip = 0;
      this.expenses = [];
      this.clearSelection();
    }
    this._ExpensesReportService.getExpensesReport(this.filter).subscribe((expenses: any) => {
      this.expenses = _.concat(this.expenses, expenses);
      const filter: any = this.filter;
      this.thereAreMore = expenses.length >= filter.limit;
      this.loading = false;
      this.ref.detectChanges();
      console.log(this.expenses);
    })
  }

  loadMore() {
    if (this.thereAreMore && !this.loading) {
      const filter: any = this.filter;
      filter.skip += filter.limit;
      this.getExpensesReport();
    }
  }

  registerStringBroadcast() {
    this.scrollSubscription = this._broadcaster.on<string>('FinishScrollDown')
      .subscribe(() => {
        this.loadMore();
      });
  }

  ngOnDestroy() {
    this.scrollSubscription.unsubscribe();
  }

  sortExpenses(sort: any) {
    this.filter.sort = (typeof sort == 'string') ? sort : ((sort.direction == 'asc') ? '' : '-') + sort.active;
    this.getExpensesReport(true);
  }

  openFilter() {
    console.log('openFilter');
  }

  clearFilter() {
    this.filter.filters = { isDeleted: false };
    this.getExpensesReport(true);
  }

  clearSelection() {
    this.selection = { all: false }
  }
  checkSomeSelected() {
    this.selection.some = Object.keys(this.selection)
      .filter(el => el !== 'all' && el !== 'some')
      .filter(el => this.selection[el])
      .length > 0;
  }
  
  toggleSelection(_id?: string) {
    if (_id) {
      // Modificar la selección de un elemento individual
      this.selection[_id] = !this.selection[_id];

      // Verificar si todos los elementos están seleccionados
      const allSelected = this.expenses.every(expense => {
        const id = expense?._id || '';
        return this.selection[id];
      });

      // Actualizar "seleccionar todos" en base a los elementos seleccionados
      this.selection.all = allSelected;
    } else {
      // Seleccionar o deseleccionar todos
      const newValue = !this.selection.all;
      this.selection = { all: newValue };

      // Aplicar el nuevo estado a todos los elementos
      this.expenses.forEach(expense => {
        const id = expense?._id || '';
        this.selection[id] = newValue;
      });
    }

    // Actualizar si hay alguna selección
    this.checkSomeSelected();
  }
}